import api, { baseURL } from "."

const getCitiesAndZipCode = async () => {
    return await api
        .get(`${baseURL}/localities`)
        .then(({ data }) => data.locations);

}
export { getCitiesAndZipCode }